export default [{
    title: "Legal",
    fontIcon: "balance-scale",
    resource: "Legal",
    action: "ver-legal",
    children: [{
        title: "Dashboard",
        icon: "LayoutIcon",
        resource: "Legal",
        action: "ver-legal-dashboard",
    }, {
        title: "Configuracion",
        icon: "SettingsIcon",
        resource: "Legal",
        action: "ver-legal-configuracion",
        children: [
            {
                fontIcon: "user-lock",
                route: "permisos-legal",
                title: "legal.configuracion.permisos_usuarios.titulo",
                resource: "Legal",
                action: "ver-legal-configuracion-permisos-legal",
            }, 
            {
                fontIcon: "building-lock",
                route: "permisos-organigrama-empresarial",
                title: "legal.configuracion.permisos_organigrama.titulo",
                resource: "Legal",
                action: "ver-legal-configuracion-permisos-organigrama",
            }, 
        ]
    }, {
        title: "Mantenimiento",
        icon: "EditIcon",
        resource: "Legal",
        action: "ver-legal-mantenimiento",
        children: [
            // {
            //     route: "mantenimiento-organigrama",
            //     title: "Organigrama",
            //     resource: "Legal",
            //     action: "ver-legal-mantenimiento-organigrama",
            // },
            {
                fontIcon: "building",
                route: "mantenimiento-empresa",
                title: "legal.mantenimiento.empresa.titulo",
                resource: "Legal",
                action: "ver-legal-mantenimiento-empresa",
            },
            {
                fontIcon: "user-pen",
                route: "mantenimiento-persona",
                title: "legal.mantenimiento.persona.titulo",
                resource: "Legal",
                action: "ver-legal-mantenimiento-persona",
            },
            {
                route: "subir-documentos",
                title: "legal.mantenimiento.documento_legal.titulo",
                resource: "Legal",
                action: "ver-legal-subir-documentos",
            },
            {
                route: "mantenimiento-tipo-documento",
                title: "legal.mantenimiento.tipo_documento.titulo",
                resource: "Legal",
                action: "ver-legal-mantenimiento-localidad",
            }
        ]
    }, {
        title: "Transacciones",
        fontIcon: "exchange-alt",
        resource: "Legal",
        action: "ver-legal-transacciones",
        children: [
            {
                route: "formato-contratos",
                title: "legal.transacciones.formato_contrato.titulo",
                resource: "Legal",
                action: "ver-legal-formato-contratos",
            }, {
                route: "estados-financieros",
                title: "legal.transacciones.estado_financiero.titulo",
                resource: "Legal",
                action: "ver-legal-estados-financieros",
            }
        ]
    }, {
        title: "Informes",
        fontIcon: "file-prescription",
        resource: "Legal",
        action: "ver-legal-informes",
        children: [
            {
                title: "legal.informes.organigrama.titulo",
                fontIcon: "sitemap",
                resource: "Legal",
                action: "ver-legal-informe-organigrama-empresarial",
                route: "organigrama-empresarial",
            },
            {
                fontIcon: "building",
                title: "legal.informes.info_empresa.titulo",
                resource: "Legal",
                action: "ver-legal-informe-informacion-empresa",
                route: "informacion-empresa",
            },
        ]
    }, ]
}, ]